/**
 * Which actions are offered on a guest video call. A guest call is 1:1: the PBX refuses blind and attended transfer, invite
 * of a third party, listen-in, takeover, pickup and barge on it. Hold, hang up and the camera work. The components and the
 * drag and drop use these, so the user is not offered an action that fails.
 */

interface MaybeGuestCall {
	guest?: boolean
}

/** The drag item and target types that matter here - the string values of CallDragItemType and CallDragTargetType */
type DragType = string | undefined

/**
 * Whether a call is a guest call
 * @param call The call, if any
 */
export function isGuestCall(call: MaybeGuestCall | null | undefined): boolean {
	return !!call?.guest
}

/**
 * Whether any of my calls is a guest call - then nothing may be transferred or added in
 * @param calls My calls
 */
export function hasGuestCall(calls: readonly MaybeGuestCall[]): boolean {
	return calls.some(isGuestCall)
}

/**
 * Whether a drop must be refused because it would move a guest call: my own guest call is never dragged, and another
 * employee's guest call is neither picked up (onto MyCalls), blind transferred (onto an employee) nor put in a queue (onto
 * the callers). Dropping an employee on the queue members only adds the extension to the queue and leaves the call alone.
 * @param itemType The type of what is dragged
 * @param item What is dragged
 * @param targetType The type of what it is dropped on
 */
export function isGuestDropRefused(itemType: DragType, item: unknown, targetType: DragType): boolean {
	if (itemType === 'MyCallsCall') { return isGuestCall(item as MaybeGuestCall) }

	if (itemType === 'Employee' && (targetType === 'MyCalls' || targetType === 'Employee' || targetType === 'QueueCallers')) {
		const employee = item as { currentCall?: MaybeGuestCall, currentRingingCall?: MaybeGuestCall } | undefined

		return isGuestCall(employee?.currentCall) || isGuestCall(employee?.currentRingingCall)
	}

	return false
}
